// Cierre de caja — algoritmo original, extraído sin modificar de js/cierre-caja.js.
// Comparte el preámbulo con borrado y difiere solo en la combinación final.
// En el original `suc` y `hs` se asignaban sin declarar (globales implícitas).
// Verificado contra tools/caracterizacion/golden.json.

export function validar({ hora }) {
  const hs = parseInt(hora, 10);
  if (isNaN(hs) || hs > 24 || hs < 1) {
    return 'La hora ingresada no es válida';
  }
  return null;
}

export function calcular({ hora, sucursal }, hoy = new Date()) {
  const suc = parseInt(sucursal, 10);
  const hs = parseInt(hora, 10);

  let pass = hoy.getFullYear();
  const mes = hoy.getMonth() + 1;
  const dia = hoy.getDate();

  if (dia >= 15) {
    if (dia % 2 == 0) {
      pass = pass + (mes * 100) + dia;
    } else {
      pass = pass + (dia * 100) + (mes * 2);
    }
  } else {
    if (dia % 2 == 0) {
      pass = pass + (mes * 100) + (dia * 3);
    } else {
      pass = pass + (dia * 200) + (mes * 4);
    }
  }
  const codigo = pass + (hs * 150) + (suc * 2);

  return {
    codigo,
    detalle: { sucursalId: suc, hora: hs },
  };
}
